import {converJsonToCsv} from '../../shared/dataConversion';

export default function csvDownload(cvResults) {
  let dataJson = [];
  //warnings
  let warnings = [];
  if(cvResults.status){
    warnings = cvResults.status.map((warning) => {
      return warning.description;
    });
  }
  dataJson.push({
    element: 'Warnings',
    value: '\'' + warnings + '\''
  });
  //findings
  if (cvResults.results) {
    cvResults.results.map((result) => {
      if(result.description === 'Makeup') {
        return null;
      }
      dataJson.push({
        element: `${result.description} overall value`,
        value: result.value
      });
      result.measurement_locations.map((location) => {
        return dataJson.push({
          element: `${result.description} ${location.description}`,
          value: location.value
        });
      });
      return null;
    });
  }
  
  let dataStr = 'data:text/csv;charset=utf-8,' + converJsonToCsv(dataJson);
  let downloadAnchorNode = document.createElement('a');
  downloadAnchorNode.setAttribute('href', encodeURI(dataStr));
  downloadAnchorNode.setAttribute('target', '_blank');
  downloadAnchorNode.setAttribute('download', 'revieveData.csv');
  document.body.appendChild(downloadAnchorNode); // required for firefox
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
}


// WEBPACK FOOTER //
// ./src/components/shareModules/csvDownload.js